import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Colors from '../../constants/color';

export const InputForm = styled(TextField)`
  font-size: 14px;
  font-family: 'Graphik-Regular';
  color: ${Colors.grey1};
  margin-bottom: 32px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 14px;
  font-family: 'Graphik-Bold';
  color: ${Colors.grey2};
  margin-bottom: 6px;
`;

export const styles = {
  input: {
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 15,
    marginTop: 10,
  },
};
